export const bg = {
  nav: {
    home: 'НАЧАЛO',
    rsvp: 'ОТГОВОР',
    details: 'ДЕТАЙЛИ',
    gallery: 'ГАЛЕРИЯ',
    travel: 'ПЪТУВАНЕ',
    dressCode: 'ДРЕСКОД'
  },
  home: {
    invitation: 'ЩЕ СЕ РАДВАМЕ\nДА ВИ ВИДИМ\nВ ДЕНЯ НА НАШАТА\nСВАТБА',
    coupleNames: 'ПОЛИНА И ЕВГЕНИЙ',
    date: '07.09.2026',
    dateRange: '6-8 септември 2026',
    location: 'Talici Hill, Черна гора',
    locationLabel: 'МЯСТО',
    venueName: 'Talici Hill',
    venueLocation: 'Черна гора',
    countdown: 'Време до церемонията',
    days: 'ДНИ',
    hours: 'ЧАСА',
    minutes: 'МИНУТИ',
    seconds: 'СЕКУНДИ',
    rsvpButton: 'Формуляр за отговор',
    rsvpSubtext: 'Уведомете ни дали можете да се присъедините',
    addToCalendar: 'Добавете в календара'
  },
  rsvp: {
    title: 'Отговор на поканата',
    subtitle: 'Моля, уведомете ни дали можете да присъствате',
    guestInfo: 'Информация за гост',
    firstName: 'Име',
    lastName: 'Фамилия',
    email: 'Имейл адрес',
    phone: 'Телефонен номер',
    attendance: 'Ще присъствате ли?',
    attendingYes: 'С радост приемам',
    attendingNo: 'За съжаление не мога',
    whichDays: 'Кои дни ще присъствате?',
    day1: '6 септември (Приветствена вечеря)',
    day2: '7 септември (Сватбен ден)',
    day3: '8 септември (Прощален бранч)',
    selectOneDay: '* Моля, изберете поне един ден',
    addGuest: '+ Добавяне на гост',
    addGuestNote: 'Кликнете, за да добавите допълнителни гости към вашия отговор',
    guestNumber: 'Гост',
    information: 'Информация',
    remove: 'Премахване',
    bringingKids: 'С деца',
    numberOfKids: 'Брой деца',
    dietary: 'Хранителни ограничения',
    dietaryNone: 'Няма',
    dietaryVegetarian: 'Вегетарианство',
    dietaryVegan: 'Веганство',
    dietaryGlutenFree: 'Без глутен',
    dietaryOther: 'Друго',
    dietaryDetails: 'Детайли за диетата',
    message: 'Съобщение до двойката',
    submit: 'Изпращане на отговор',
    submitting: 'Изпращане...',
    thankYou: 'Благодарим!',
    successMessage: 'Вашата информация беше успешно изпратена.',
    successMessage2: 'Получихме вашия отговор и с нетърпение очакваме да празнуваме с вас!',
    confirmationEmail: 'Ще получите потвърждение на предоставения имейл адрес.'
  },
  schedule: {
    title: 'Три дни празник',
    subtitle: 'Присъединете се към нас за вълшебен уикенд в Черна гора',
    day1Title: 'Приветствена вечеря',
    day2Title: 'Сватбена церемония',
    day3Title: 'Прощален бранч',
    time: 'Време',
    location: 'Място',
    dates: {
      day1: '6 септември',
      day2: '7 септември',
      day3: '8 септември'
    },
    events: {
      day1: {
        event1: {
          title: 'Пристигане на мястото',
          description: 'Добре дошли в Talici Hill!',
          location: 'Рецепция Talici Hill'
        },
        event2: {
          title: 'Начало на приветствената вечеря',
          description: 'Присъединете се към нас за приятна приветствена вечеря, за да започнем празненството.',
          location: 'Градина Talici Hill'
        },
        event3: {
          title: 'Край на приветствената вечеря',
          description: 'Приключване на вечерта и почивка преди важния ден.',
          location: 'Градина Talici Hill'
        }
      },
      day2: {
        event1: {
          title: 'Приветствени напитки на вилата',
          description: 'Съберете се за напитки преди церемонията и общувайте с гостите.',
          location: 'Рецепция Talici Hill'
        },
        event2: {
          title: 'Фотосесия',
          description: 'Професионална фотосесия с двойката и сватбената група.',
          location: 'Градина за церемонията'
        },
        event3: {
          title: 'Церемония',
          description: 'Бъдете свидетели на нашите обети в интимна церемония с изглед към Адриатическо море.',
          location: 'Градина за церемонията'
        },
        event4: {
          title: 'Аперитив',
          description: 'Празнувайте с шампанско и канапета, наслаждавайки се на залеза.',
          location: 'Зона за вечеря'
        },
        event5: {
          title: 'Вечеря',
          description: 'Многостепенна вечеря.',
          location: 'Зона за вечеря'
        },
        event6: {
          title: 'Торта',
          description: 'Присъединете се към нас за разрязването на сватбената торта.',
          location: 'Зона за вечеря'
        },
        event7: {
          title: 'Купон',
          description: 'Танцувайте цялата нощ под небето на Черна гора.',
          location: 'Зона за вечеря'
        }
      },
      day3: {
        event1: {
          title: 'Парти при басейна и пица',
          description: 'Присъединете се към нас за релаксиращо парти при басейна с вкусна пица, за да завършим празненството.',
          location: 'Зона на басейна Talici Hill'
        }
      }
    },
    dressCode: {
      title: 'Какво да облечем',
      intro: 'Толкова се радваме да празнуваме сватбата с вас! С наближаването на важния ден искахме да споделим няколко детайла, които да ви помогнат да се подготвите за уикенда в Черна гора.',
      sunday: 'Неделя, 6 септември: Приветствена вечеря',
      sundayDesc: 'Ще започнем с непринудена барбекю вечеря.',
      sundayCode: 'Дрескод: Smart-Casual/Casual',
      monday: 'Понеделник, 7 септември: Сватбеният ден',
      mondayDesc: 'Нашата церемония ще се проведе на фона на Средиземно море и черногорските планини.',
      mondayCode: 'Дрескод: Summer Outdoor Black Tie',
      mondayNote: '(Искаме да се облечете елегантно и да се забавлявате!)',
      ladies: 'Дами:',
      ladiesDesc: 'Запазваме елегантната вечерна атмосфера, но строгото правило за дълги рокли до пода е премахнато! Моля, изберете елегантни платове с дължина от средата на прасеца до пода (цветните рокли все още са силно насърчавани!). Завършете визията си с любимите си обувки на ток или елегантни сандали.',
      gentlemen: 'Господа:',
      gentlemenDesc: 'Черен смокинг (или традиционна килт, където е подходящо) е силно предпочитан. Ако обаче те не са налични, черен костюм е приемлива алтернатива. Можете да допълните визията с папионка (предпочитана) или да изберете стил с отворена яка.',
      tuxedoNote: '* Забележка: Ако имате нужда от смокинг, има варианти за наем на разумни цени.',
      tuesday: 'Вторник, 8 септември: Прощален бранч при басейна',
      tuesdayDesc: 'Плажно парти, повседневно или леко облекло. Не забравяйте бански костюм, за да се насладим максимално на басейна, ако грее слънце!',
      tuesdayCode: 'Дрескод: Casual/Beachwear',
      viewGallery: 'Вижте галерията за вдъхновение →',
      galleryNote: 'Разгледайте нашата подбрана колекция от идеи за тоалети и стилово вдъхновение',
      closing: 'С нетърпение очакваме скоро да ви видим! Моля, свържете се с нас, ако имате въпроси.',
      detailTitle: 'Скъпи гости! 🤍',
      detailIntro: 'Получихме доста въпроси относно дрескода, затова искахме да изясним всичко и да ви улесним максимално при планирането на тоалетите за нашия специален ден!',
      detailTheme: 'Нашата тема е Летен-Шик Черна Вратовръзка (Summer-Chic Black Tie). Тъй като е лято, смекчихме строгите традиционни правила за всички! Моля обаче, запомнете най-важната ви задача за вечерта: да изглеждате абсолютно зашеметяващи, гламурозни и да затъмните всички около вас! 😉',
      detailGuidelines: 'За да ви помогнем да съставите вашите визии, ето нашите прости насоки:',
      detailColorPalette: '✨ Цветова палитра: Приветстваме абсолютно всички цветове и нюанси — от нежни пастелни до ярки, сочни летни тонове. Дори ярко червена рокля е абсолютно позволена и насърчавана! Молим само дамите да избягват два конкретни цвята: бяло (запазен за булката) и черно (нека запазим лятото ни цветно и весело!). Това правило важи само за дами.',
      detailLadies: '👗 За дами: Строгото изискване за "задължително дълги до пода" рокли е премахнато, но определено запазваме вечерната атмосфера. Дължината на вашата рокля трябва да е от средата на прасеца надолу до пода. Изберете елегантни платове. И разбира се, не забравяйте любимите си обувки на ток или елегантни сандали.',
      detailGentlemen: '👔 За господа: Намалихме строгостта и за мъжете! Класически смокинг или просто много елегантен черен костюм с бяла риза е перфектният избор. Папионка или класическа вратовръзка този път са по избор, но ще бъдем МНОГО щастливи да ги видим! Нека внесем заедно този специален щрих на елегантност. 🤍',
      detailFlexibility: 'Разбира се, ако все още имате въпроси или ви е абсолютно невъзможно да отговорите перфектно на дрескода — моля, не се притеснявайте, никой няма да ви изпрати! Най-важното за нас е вие да сте там с нас, вашите усмивки, вашата лъчезарна енергия и вашият комфорт.',
      detailClosing: 'Нямаме търпение да празнуваме с вас!'
    },
    weather: {
      title: 'Очаквано време',
      subtitle: 'Черна гора през септември'
    },
    venue: {
      title: 'Място на провеждане',
      getDirections: 'Маршрут',
      visitWebsite: 'Посетете уебсайта'
    }
  },
  gallery: {
    title: 'Галерия',
    subtitle: 'Talici Hill, Черна гора',
    dressCode: 'Вдъхновение за дрескод',
    dressCodeSubtitle: 'Вдъхновете се за нашето лятно празненство'
  },
  whatsapp: {
    joinChannel: 'Присъединете се към нашия WhatsApp канал за всички актуализации',
    joinGroup: 'Присъединете се към нашата WhatsApp група'
  },
  travel: {
    title: 'Пътуване и настаняване',
    subtitle: 'Всичко, което трябва да знаете за пътуването до Черна гора',
    accommodation: {
      title: 'Къде да отседнете',
      recommendation: 'Опции за настаняване',
      description: 'В близост до Talici Hill има много варианти за настаняване, включително хотели и апартаменти (като Apartments Villa Mare Mar) или наем на вили.',
      groupTip: 'Съвет: Помислете за споделяне на вила',
      groupDescription: 'Ако изберете да наемете вила, помислете да се координирате с други гости, за да споделите по-голям имот с 4-5 спални. Ще получите повече пространство, частен басейн и по-добро преживяване като цяло.',
      whatsappPrompt: 'Използвайте нашия WhatsApp канал, за да се свържете с други гости и да организирате настаняване!'
    },
    gettingThere: {
      title: 'Как да стигнете',
      airport: 'Най-близки летища',
      airportTivat: 'Летище Тиват (TIV)',
      airportPodgorica: 'Летище Подгорица (TGD)',
      airportDubrovnik: 'Летище Дубровник (DBV, Хърватия)',
      transport: 'Транспортни опции',
      carRental: 'Наем на кола - Препоръчително за гъвкавост',
      taxi: 'Такси/Трансфер - Достъпни от всички летища',
      rideshare: 'Приложения за споделено пътуване налични в Черна гора'
    },
    localInfo: {
      title: 'Местна информация',
      currency: 'Валута: Евро (€)',
      language: 'Език: Черногорски (английският е широко разпространен в туристическите зони)',
      weather: 'Време през септември: Топло и слънчево, 20-28°C',
      whatToPack: 'Какво да вземете: Бански, слънцезащитен крем, удобни обувки и танцувален тоалет!'
    }
  },
  travelForm: {
    title: 'Анкета за гости',
    intro1: 'Скъпи гости!',
    intro2: 'Молим ви да отговорите на няколко въпроса по-долу, за да можем да направим престоя ви на нашата сватба в Черна гора възможно най-комфортен и приятен.',
    intro3: 'Благодарим ви! Очакваме ви с нетърпение!',
    person: 'Гост',
    selectName: 'Вашето име',
    selectNamePlaceholder: 'Изберете вашето име от списъка с гости...',
    selectNameNote: 'Не намирате името си? Свържете се с нас.',
    personalInfo: 'Лична информация',
    phone: 'Телефонен номер (Telegram / WhatsApp)',
    travelDetails: 'Полет и пътуване',
    travelModeQ: 'Как ще пристигнете?',
    travelModeFlight: 'Със самолет',
    travelModeOther: 'Друго (кола, влак...)',
    arrivalDay: 'Ден на пристигане',
    airport: 'Летище',
    airportTivat: 'Тиват',
    airportPodgorica: 'Подгорица',
    airportOther: 'Друго',
    airportOtherPlaceholder: 'Моля, посочете летището',
    arrival: 'Пристигане',
    departure: 'Заминаване',
    date: 'Дата',
    pickDate: 'Изберете дата',
    time: 'Час',
    flight: 'Авиокомпания и номер на полета',
    flightPlaceholder: 'напр. Air Serbia JU662',
    transferArrivalQ: 'Нуждаете ли се от трансфер летище → хотел при пристигане?',
    transferDepartureQ: 'Нуждаете ли се от трансфер хотел → летище при заминаване?',
    transferYes: 'Да',
    transferNo: 'Не, ще се организирам сам',
    transferOther: 'Друго',
    transferOtherPlaceholder: 'Моля, уточнете',
    accommodation: 'Настаняване',
    hotelQ: 'В кой хотел ще отседнете?',
    hotelPlaceholder: 'Име на хотела',
    menuTitle: 'Меню · 7 септември',
    coldAppetizerQ: 'Студено предястие',
    coldMontenegrin: 'Традиционно черногорско предястие (негушки пършут, домашно сирене, пушено сирене, сирене с билки, маслини)',
    coldSalmon: 'Тартар от сьомга с авокадо и мариновано алабаш',
    coldVegan: 'Веган вариант: салата от киноа със сушени домати, авокадо и слънчогледови семки',
    mainCourseQ: 'Основно ястие',
    mainMonkfish: 'Морски дявол с шафраново ризото и свежи кълнове',
    mainBeef: 'Телешки медальони със задушени зеленчуци и пюре от целина',
    mainVegan: 'Веган вариант: тофу на грил със зеленчуци и сос от смокини',
    allergiesQ: 'Алергии или хранителни ограничения',
    allergyLactose: 'Лактоза',
    allergyGluten: 'Глутен',
    allergyCitrus: 'Цитрусови плодове',
    allergyNuts: 'Ядки',
    allergyRedFruits: 'Червени плодове и зеленчуци',
    allergyOther: 'Друго',
    allergyOtherPlaceholder: 'Моля, уточнете',
    flowerAllergyNote: '* Ако имате алергия към цветя, моля, също ни уведомете.',
    drinksTitle: 'Напитки',
    drinksQ: 'Предпочитани напитки',
    drinkWhiteWine: 'Бяло вино',
    drinkRedWine: 'Червено вино',
    drinkRose: 'Розе',
    drinkSparkling: 'Пенливо вино',
    drinkBeer: 'Бира',
    drinkRakija: 'Местна ракия',
    drinkVodka: 'Водка',
    drinkGin: 'Джин',
    drinkWhisky: 'Уиски',
    drinkRum: 'Ром',
    drinkTequila: 'Текила',
    childrenTitle: 'За гости с деца',
    childQ: 'Планирате ли да дойдете с дете? Ако да, моля, кажете ни дали можем да направим нещо, за да бъде престоят ви по-комфортен.',
    childPlaceholder: 'Вашият отговор (по избор)',
    beautyTitle: 'Услуги на стилисти',
    beautyQ: 'В деня на сватбата в хотела ще има стилисти — желаете ли:',
    beautyMakeup: 'Грим — цената се уточнява',
    beautyHair: 'Прическа — цената се уточнява',
    beautyFullLook: 'Цялостна визия (грим + прическа) — цената се уточнява',
    beautyNone: 'Не, благодаря',
    anythingElse: 'Нещо друго?',
    commentsQ: 'Нещо друго? Въпроси, пожелания, коментари',
    commentsPlaceholder: 'Вашият отговор (по избор)',
    addPerson: '+ Добави гост',
    addPersonNote: 'Попълвате анкетата за семейство или приятели? Добавете ги тук.',
    removePerson: 'Премахни',
    whoSection: 'Изберете гости',
    addChild: '+ Добави дете',
    addChildNote: 'За децата има отделно меню.',
    childLabel: 'Дете',
    childName: 'Име и фамилия на детето',
    childNamePlaceholder: 'напр. Анна Иванова',
    sameTravel: 'Същата информация за пътуването като',
    detailsFor: 'Анкета за',
    flightFor: 'Полет и пътуване за',
    kidsMenuTitle: 'Детско меню · 7 септември',
    kidsAppetizerQ: 'Предястие',
    kidsAppPastaCheese: 'Паста със сирене',
    kidsAppPastaNapolitan: 'Паста Наполитан',
    kidsAppMozzarella: 'Хрупкави моцарела пръчици',
    kidsMainQ: 'Основно ястие',
    kidsMainNuggets: 'Пилешки хапки с пържени картофи',
    kidsMainChicken: 'Пилешко филе с картофено пюре',
    kidsMainBurger: 'Бургер с пържени картофи',
    submit: 'Изпрати',
    submitting: 'Изпращане...',
    errorSelectName: 'Моля, изберете име за всеки гост',
    errorChildName: 'Моля, въведете името на детето',
    errorRequired: 'Моля, попълнете всички задължителни полета за',
    thankYou: 'Благодарим ви!',
    successMessage: 'Вашата анкета беше изпратена успешно. Нямаме търпение да празнуваме заедно с вас!',
    allSubmitted: 'Изглежда, че всички гости вече са попълнили анкетата. Благодарим ви!',
    alreadySubmittedTag: 'анкетата вече е попълнена',
    alreadySubmittedTitle: 'Анкетата вече е попълнена',
    alreadySubmittedIntro: 'Вече получихме анкета за',
    alreadySubmittedContact: 'Ако трябва да промените или допълните нещо, моля, свържете се директно с Полина или Евгений — с удоволствие ще ви помогнем.',
    alreadySubmittedOk: 'Разбрах',
    loadError: 'Неуспешно зареждане на списъка с гости. Моля, презаредете страницата.'
  }
};
